import React, { useEffect } from "react";
import { Rept } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { mt } from "../../../../St/comps/cStyle";
import { reFormatDate } from "../../../../utils/utils";
import { colors, Container, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export function TotalsMulto(props) {
  const {infoData,totalvat,net_amount}=props;
  const cls = useRptAF();
  const totals = infoData.dataH;

  const styleE = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    padding: 2,
    fontSize: "0.6rem",
    color: "red",
    fontWeight: "bold",
  };
  const styleTo = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: "bold",
  };
  const { t } = useTranslation("forms");

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container className={cls.rootBdyup}>
        <Grid container lg={12} md={12} className={cls.rootBdydown}>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={4} style={styleE}>
              {"الاجمالي"}
            </Grid>
            {parseFloat(totalvat)>0?null:
            (
              <Grid item xs={4} style={styleE}>
              {"ضريبة القيمة المضافة%"}
              </Grid>
            )
            }
            <Grid item xs={4} style={styleE}>
              {"ضريبة القيمة المضافة"}
            </Grid>
            {parseFloat(totalvat)>0&&
            (
              <Grid item xs={4} style={styleE}>
              {t("net")}
            </Grid>
            )
            }
                
          </Grid>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={4} style={styleTo}>
              {totals?.val?.toFixed(2)}
            </Grid>
            {parseFloat(totalvat)>0?null:
            (
              <Grid item xs={4} style={styleTo}>
              {totals?.taxperc?.toFixed(2)}
              </Grid>
            )
            }
            <Grid item xs={4} style={styleTo}>
              {totals?.taxval?.toFixed(2)}
            </Grid>
            {parseFloat(totalvat)>0&&
            (
              <Grid item xs={4} style={styleTo}>
              {net_amount?.toFixed(2)}
              </Grid>
            )
            }
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function BodyMulti({ data, infoData, isLast }) {
  const { t } = useTranslation("forms");

  var columns = [
    { title: "كود الحساب", field: "acc_no" },

    { title: "اسم الحساب", field: "name" },
    
    { title: "القيمة", field: "credit" ,},
    { title: t("vat_perc"), field: "taxperc", hidden:infoData.kind || parseFloat(infoData.dataH)>0},
    { title: t("vat_total"), field: "taxval", hidden: infoData.kind || parseFloat(infoData.dataH.taxperc)>0},
    { title: t("net"), field: "netamount", hidden: infoData.kind ||parseFloat(infoData.dataH.taxperc)>0 },
    { title: "رقم المرجع", field: "refno" ,},

    {
      title: "البيان",
      field: "notes",
      cellStyle: {
        
        padding: "5px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        width: "200px",
        fontWeight:"bold",
        border: "solid 0.1px",
        fontFamily: "Amiri-Regular",
        fontSize: "0.7rem",
      },
    },
  ];

  const data2 = data.map((row) => {
    return {
      ...row, 
      credit: parseFloat(row.credit)?.toFixed(2),
    };
  });
  const totalvat = data?.reduce((a, v) => (a = a + parseFloat(v?.taxval)), 0);
  const net_amount = data?.reduce((a, v) => (a = a + parseFloat(v?.netamount)??0), 0);
  return (
    <Grid item container style={{fontFamily: "Amiri-Regular"}}>
      <Grid item container style={{ direction: "rtl",paddingTop:"0.7rem"}}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none",width:"100%" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",
               
                
              },
              paging: false,
             // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
              // maxBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
              // minBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={data2}
          />
          {isLast && <TotalsMulto infoData={infoData} totalvat={totalvat} net_amount={net_amount}/>}
        </Grid>
       
      </Grid>
     
      
    </Grid>
  );
}

export default BodyMulti;
